/**
 * Presentation-only half of the module catalog.
 */
const MODULE_COPY = {
    amazon_visibility_suite: {
        confirm: {
            on: {
                title: "CAUTION: HIGH COST ACTION AHEAD",
                message:
                    "You are about to activate the Amazon Insights feature. " +
                    "This action is NOT reversible and leads to significant data processing " +
                    "costs for our company. This feature should ONLY be activated if included " +
                    "in a signed contract. Please confirm that you are certain that Amazon " +
                    "Insights is in a signed contract before proceeding. Are you absolutely " +
                    "certain you want to proceed?",
                yes: "Yes, I've confirmed the contract includes it",
                no: "No, I need to double-check",
                size: "lg",
            },
        },
        feedback: {
            on:
                "This setting will trigger the platform to process an entire year of data for this " +
                "brand, which is expensive. Please make sure this should be enabled before clicking" +
                "Save because this action is logged and if you enable it by mistake, it will be" +
                "known.",
        },
    },
};

export default MODULE_COPY;
